module.exports = __webpack_public_path__ + "img/BIT_white02.5740c6bd.jpg";